<div>
    <div class="tw-flex tw-justify-between tw-items-center">
        <h2 class="mb-0" mat-dialog-title>
            Lendio Email Directory
        </h2>
        <mat-icon
            mat-dialog-close
            (click)="close()">
            close
        </mat-icon>
    </div>

    <mat-dialog-content>
        <mat-form-field class="tw-w-full tw-pt-2">
            <input
                type="text"
                placeholder="Search Directory"
                [formControl]="control"
                matInput
                [matAutocomplete]="auto"
                [ngStyle]="{'color': '#0082FF'}">
            <mat-autocomplete #auto="matAutocomplete">
            <cdk-virtual-scroll-viewport
                [ngStyle]="{'height': autocompleteHeight}"
                itemSize="25">
                <mat-option *cdkVirtualFor="let lendion of filteredLendions"
                    [value]="lendion.fullName"
                    class="tw-h-12"
                    (click)="addLendionRecipient(lendion)">
                    <div class="tw-h-12 tw-flex tw-flex-row tw-items-center tw-justify-start tw-leading-12">
                        <div>{{ lendion?.fullName }}</div>
                    </div>
                </mat-option>
            </cdk-virtual-scroll-viewport>
            </mat-autocomplete>
        </mat-form-field>
    </mat-dialog-content>
</div>
